import React, { FunctionComponent, ReactElement } from 'react';
import Translation from '../../../../common/components/translation/Translation';
import { GetCustomizeCar_customizeCar_disclaimers } from '../../../graphql/queries/__generated__/GetCustomizeCar';
import { Typography } from '@material-ui/core';
import { useIntl } from 'react-intl';

interface IProps {
  className?: string;
  index: number;
  disclaimer: GetCustomizeCar_customizeCar_disclaimers;
  disclaimerContentValues: {
    vehicle_display_name?: string;
    model?: string;
    bodystyle?: string;
  };
}

const DisclaimerElement: FunctionComponent<IProps> = ({
  index,
  disclaimer,
  className,
  disclaimerContentValues,
}: IProps) => {
  const intl = useIntl();
  let translatableIndicativeNumber = '';
  let translatableText = '';

  if (disclaimer.needsToBeTranslated) {
    const translatableDisclaimer = JSON.parse(disclaimer.value);
    translatableIndicativeNumber = translatableDisclaimer.indicativeNumber;
    translatableText = translatableDisclaimer.text;
  }

  const renderDisclaimer = (value: string): ReactElement => <span dangerouslySetInnerHTML={{ __html: value }} />;

  return disclaimer.needsToBeTranslated ? (
    <Typography
      variant="subtitle1"
      className={className}
      key={index}
      data-test={`customise:disclaimer:${index}`}
      component="span"
    >
      <Translation id={translatableIndicativeNumber} /> <Translation id={translatableText} />
    </Typography>
  ) : (
    <Typography
      variant="subtitle1"
      className={className}
      key={index}
      data-test={`customise:disclaimer:${index}`}
      component="span"
    >
      {renderDisclaimer(
        intl.formatMessage(
          { id: 'trans__configurator__customise_page_disclaimers', defaultMessage: disclaimer.value },
          disclaimerContentValues,
        ),
      )}
    </Typography>
  );
};

export default DisclaimerElement;
